import { render, staticRenderFns } from "./front-distributionorder-list.vue?vue&type=template&id=1c5126c5&"
import script from "./front-distributionorder-list.vue?vue&type=script&lang=ts&"
export * from "./front-distributionorder-list.vue?vue&type=script&lang=ts&"
import style0 from "./front-distributionorder-list.vue?vue&type=style&index=0&lang=css&"
import style1 from "./front-distributionorder-list.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports